module.exports = __webpack_public_path__ + "static/img/certificate.a8297cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/certificate.png
// module id = LJvb
// module chunks = 0